$(function () {
    // Search bar
    $('.navbar-search .submit').on('click', function (ev) {
        const $parent = $(this).closest('.navbar-search'),
            $txt = $parent.find('input[type=text]');

        if ($txt.val().trim() !== '') { return true; }

        ev.preventDefault();
        ev.stopPropagation();
        $parent.addClass('open has-focus');
        $('.navbar').addClass('navbar-search-open');
        // wait before setting focus
        window.setTimeout(function () {
            $txt.focus();
        }, 200);
        return false;
    });
    $('.navbar-search input[type=text]').blur(function () {
        const $txt = $(this);
        if ($txt.val().trim() !== '') { return; }
        const $parent = $(this).closest('.navbar-search').removeClass('has-focus');
        window.setTimeout(function () {
            if (!$parent.is('.has-focus')) {
                $('.navbar').removeClass('navbar-search-open');
                $parent.removeClass('open');
            }
        }, 200);
    });

    // toggle menu
    $('.navbar .has-children').on('click', function (ev) {
        const $this = $(this).closest('.has-children');
        if ($this.is('.navbar-open')) {
            $this.removeClass('navbar-open').closest('.navbar-menu').removeClass('navbar-open');
        } else {
            ev.preventDefault();
            $this.siblings().removeClass('navbar-open');
            $this.addClass('navbar-open').closest('.navbar-menu').addClass('navbar-open');
        }
    });
    $('.navbar').on('click', function (ev) {
        !$(ev.target).closest('.has-children').length && $('.navbar .navbar-open').removeClass('navbar-open');
    });

    // toggle mega menu
    $('[data-toggle-menu]').on('click', function (ev) {
        ev.preventDefault();
        ev.stopPropagation();
        $('.navbar .navbar-open').removeClass('navbar-open');
        $('body').toggleClass('navbar-open');
    });

    // add "fixed" when scrolling
    const updateScroll = function () {
        const $navBar = $('.navbar');
        const $wrapper = $navBar.find('.navbar-wrapper');
        const scrollTop = $(this).scrollTop();
        let pastTop = ($navBar.position().top + $navBar.height()) < scrollTop;
        if (pastTop && !$wrapper.is('.fixed-top')) {
            $wrapper.addClass('fixed-top');
            $('.navbar .navbar-open').removeClass('navbar-open');
        } else if (!pastTop && $wrapper.is('.fixed-top')) {
            $wrapper.removeClass('fixed-top');
            $('.navbar .navbar-open').removeClass('navbar-open');
        }

        // do the same for all "scroll-fixed" elements (there should only be one on the page)
        const $scrollFixed = $('.scroll-fixed');
        if ($scrollFixed.length) {
            const extraTop = $wrapper.is('.fixed-top') ? $wrapper.height() : 0;
            pastTop = ($scrollFixed.parent().offset().top + $scrollFixed.height() - extraTop) < scrollTop;
            if (pastTop && !$scrollFixed.is('.fixed-top')) {
                $scrollFixed.addClass('fixed-top');
            } else if (!pastTop && $scrollFixed.is('.fixed-top')) {
                $scrollFixed.removeClass('fixed-top');
            }
        }
    }
    $(document)
        .on('scroll', updateScroll)
        .on('click', function (ev) {
            if (!$(ev.target).closest('.navbar').length) {
                $('.navbar .has-children').removeClass('navbar-open').closest('.navbar-menu').removeClass('navbar-open');
            }
        })
        ;
    updateScroll();

    // navigation location when value changes in dropdown, using the "value" of the selected option
    $('[data-navigate-on-change]').on('change', function () {
        const location = $(this).val();
        if (location && location.substr(0, 1) === '#') {
            document.location.hash = location;
        } else {
            document.location.href = location;
        }
    });
});